.root {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  visibility: hidden;
}

.root--visible {
  visibility: visible;
}

.joystick {
  width: 4.75rem;
  height: 4.75rem;
  position: fixed;
  bottom: var(--spacer-2);
}

.joystick--left {
  left: var(--spacer-2);
}

.joystick--right {
  right: var(--spacer-2);
}

.ui-wrapper {
  will-change: opacity;
  transition: opacity 0.3s ease-in-out;
  opacity: 0;
  pointer-events: none;
}

.ui-wrapper--visible {
  opacity: 1;
  pointer-events: all;
}
